import type { CSSProperties, MouseEventHandler, ReactNode } from 'react';

type TextLevel = 'micro' | 'meta' | 'label' | 'body' | 'body-hi' | 'lg' | 'focal' | 'hero';

type Props = {
  level?: TextLevel;
  mono?: boolean;
  as?: 'span' | 'div' | 'p';
  style?: CSSProperties;
  className?: string;
  children?: ReactNode;
  onClick?: MouseEventHandler<HTMLElement>;
};

const classMap: Record<TextLevel, string> = {
  micro: 't-micro',
  meta: 't-meta',
  label: 't-label',
  body: 't-body',
  'body-hi': 't-body-hi',
  lg: 't-lg',
  focal: 't-focal',
  hero: 't-hero',
};

export function Text({
  level = 'body',
  mono = false,
  as: Tag = 'span',
  style,
  className,
  children,
  onClick,
}: Props) {
  const cls = [classMap[level], mono ? 'mono' : '', className ?? ''].filter(Boolean).join(' ');
  return (
    <Tag className={cls} style={style} onClick={onClick}>
      {children}
    </Tag>
  );
}

export const Mono = ({ style, children, className }: { style?: CSSProperties; children?: ReactNode; className?: string }) => (
  <span className={['mono', className ?? ''].filter(Boolean).join(' ')} style={style}>
    {children}
  </span>
);
